import { useMemo } from 'react';
import { selectSidebarOpen } from 'common/store/slices/layout.slice';
import { useSelector } from 'react-redux';
import MobileDetect from 'mobile-detect';
import { useMediaQuery } from 'react-responsive';

interface UseResize {
  isTabletOrMobile: boolean;
  isMobile: boolean;
  sideBarOpenTabletView: boolean;
  isLaptopScreen: boolean;
  isBigScreen: boolean;
}

export const useResize = (): UseResize => {
  const detectActualMobileDevice = (innerWidth: number): boolean => {
    const md = new MobileDetect(window.navigator.userAgent);

    const isMobileAgent = md.mobile() ?? md.tablet();
    const isTouchDevice = true;
    const isSmallScreen = window.innerWidth < innerWidth;

    return !!(isMobileAgent && isTouchDevice && isSmallScreen);
  };

  const isTabletOrMobile = detectActualMobileDevice(1224);
  const isMobile = detectActualMobileDevice(480);
  const sideBarOpen = useSelector(selectSidebarOpen);
  const isLaptopScreen = useMediaQuery({ query: '(max-width: 1680px)' });
  const isBigScreen = useMediaQuery({ query: '(min-width: 2000px)' });

  const sideBarOpenTabletView = useMemo(() => {
    if (sideBarOpen && isTabletOrMobile) {
      return true;
    }
    return false;
  }, [isTabletOrMobile, sideBarOpen]);

  return useMemo(
    () => ({
      isTabletOrMobile,
      isMobile: isMobile,
      sideBarOpenTabletView,
      isBigScreen,
      isLaptopScreen,
    }),
    [isTabletOrMobile, isMobile, sideBarOpenTabletView, isBigScreen, isLaptopScreen]
  );
};
